<template>
  <v-card rounded="lg" color="background">
    <v-card-title>
      Conexiones
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <div class="text-subtitle-1 mb-1 px-4 text--primary">
        Detalles de la búsqueda
      </div>
      <search-card
        :show-head="showHead"
        disabled
        :search="search"
        class="mb-3"
      ></search-card>

      <v-divider class="mb-3"></v-divider>

      <div v-if="results.length">
        <v-card color="transparent" flat>
          <v-row class="px-3 grey--text">
            <v-col cols="1" class="py-0"> </v-col>
            <v-col cols="6" class="py-0">
              <div class="font-weight-medium caption py-0 px-7">
                {{ $t("property.list.headers.property") }}
              </div>
            </v-col>
            <v-col cols="3" class="py-0">
              <div class="font-weight-medium caption py-0">
                {{ $t("property.list.headers.state") }}
              </div>
            </v-col>
            <v-col cols="3" class="py-0">
              <div class="font-weight-medium caption py-0 px-3"></div>
            </v-col>
          </v-row>
        </v-card>

        <v-row>
          <template v-for="result in results">
            <v-col cols="12" class="pb-0 text-right">
              <property-card
                :property="result.property"
                :score="result.score"
                :result="result"
              ></property-card>
            </v-col>
          </template>
        </v-row>
      </div>

      <v-alert v-else type="info" border="left" outlined>
        No hay resultados de búsqueda disponibles.
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import { Results } from "@/graphql/queries/searches";
import PropertyCard from "@/components/properties/Card";
import SearchCard from "@/components/searches/Card";

export default {
  data: () => ({
    results: []
  }),

  props: {
    search: {
      type: Object,
      required: true
    },
    showHead: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  created() {
    this.fetchResults();
  },

  methods: {
    fetchResults() {
      this.$apollo
        .query({
          query: Results,
          variables: {
            searchId: this.search.id
          }
        })
        .then(res => {
          this.results = res.data.results;
        });
    }
  },

  components: {
    PropertyCard,
    SearchCard
  }
};
</script>
